module.exports = __webpack_public_path__ + "img/link-banner-en.f48bcd05.png";